<template>
  <div class="d-flex flex-column justify-center align-center">
    <h3 class="h2 mb-4 mt-4">All set! Let's go!</h3>
    <gg-btn class="mb-4" :loading="loading" @click="login">WP-Admin Dashboard</gg-btn>
    <gg-btn text @click="$emit('skip')">Skip for now</gg-btn>
  </div>
</template>

<script>
import { makeWpLoginUrl } from '@/helpers/wp'

export default {
  name: 'InstallationComplete',
  props: {
    insid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    async login () {
      try {
        this.loading = true
        const url = await makeWpLoginUrl({ insid: this.insid, username: this.$route?.query?.user })
        const win = window.open(url, '_blank')
        if (!win) {
          throw new Error('Popup blocked by browser. Please allow popups for this site.')
        }
      } catch (e) {
        this.$emit('error', e)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
